import { io } from "socket.io-client";

const SOCKET_URL = 'https://trust-aml.pro'; // Укажи сюда свой сервер

export const socket = io(SOCKET_URL, {
    autoConnect: true,
    transports: ['websocket']
});
